import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** DELETE `/ims/stock-return/{id}`。僅 DRAFT；刪除草稿。 */
export async function cancelStockReturn(id) {
  const { data: raw } = await request.delete(`/ims/stock-return/${id}`);
  return parseVer4DetailResponse(raw);
}
